import { memo } from 'react'
import { LazyMount } from '@app/components/lazy/lazymount'
import { Analytic } from '@app/types'
import { PageBar } from '../../lists/render/issues/page-bar'
import { dataListStyle } from '../../cells/card/head-style'
import { RenderInnerPagesPagingMock } from './pages-paging-mock'

// issue card paging
const PageCardComponentMock = ({
  pageUrl,
  liveData,
  handleMainClick,
}: {
  pageUrl: string
  liveData?: Analytic[]
  handleMainClick?: any // modal
  activeSubscription?: boolean
}) => {
  return (
    <div>
      <PageBar />
      <div>
        <LazyMount className={dataListStyle}>
          <RenderInnerPagesPagingMock
            pageUrl={pageUrl}
            liveData={liveData}
            handleMainClick={handleMainClick}
          />
        </LazyMount>
      </div>
    </div>
  )
}

export const PageCardMock = memo(PageCardComponentMock)
